module.exports = __webpack_public_path__ + "img/巴德富.82c15af4.png";